/**
 * `setValueAs` helpers bridging HTML inputs (which yield "" for empty) to the
 * shared zod Input schemas (which want `null`/`undefined`/numbers).
 */

/** Empty/whitespace text → null (for `.nullish()` string fields). */
export function textOrNull(value: unknown): string | null {
  if (value == null) return null;
  const text = String(value).trim();
  return text === "" ? null : text;
}

/** Empty → null, otherwise Number(...) — NaN is kept so zod rejects typos. */
export function numberOrNull(value: unknown): number | null {
  if (value == null || value === "") return null;
  return Number(value);
}

/** Empty → undefined (required numeric fields fail validation when blank). */
export function numberOrUndefined(value: unknown): number | undefined {
  if (value == null || value === "") return undefined;
  return Number(value);
}

/**
 * CSV/whitespace-separated numbers ("15, 22") → [15, 22]. NaN entries are kept
 * so zod rejects typos; empty input → [] (an explicit "no sizes").
 */
export function numberList(value: unknown): number[] {
  if (value == null) return [];
  return String(value)
    .split(/[,\s/x×]+/i)
    .filter((part) => part !== "")
    .map((part) => Number(part));
}
